import './instagram_response_sticker_selector_view.js.coffee'

Namespace 'Customer.Ticket'

class Customer.Ticket.InstagramResponseStickerIconView extends Backbone.View
  className: 'instagram-response-sticker-icon'
  template: JST['backbone/templates/customer/ticket/sticker/instagram_response_sticker_icon']

  initialize: ->
    @enabled = false
    @canDisplay = true
    @stickerSelector = new Customer.Ticket.InstagramResponseStickerSelectorView()

  render: ->
    @$el.html(@template())
    stickerIcon = @_stickerIcon().render().el
    stickerIcon.title = I18n.t(
      'customer.dashboard.conversations.details.response.instagram.add_sticker_tooltip'
    )
    @$el.find('.sticker_icon').append(stickerIcon)
    @listenTo @stickerSelector, 'add:sticker', (name) => @_selectSticker(name)
    @$el.append(@stickerSelector.render().el)
    @

  _selectSticker: (name) ->
    @trigger 'add:sticker', name

  toggleStickers: ->
    if !@canDisplay
      return
    if @enabled
      @enabled = false
      @stickerSelector.disable()
    else
      @enabled = true
      @stickerSelector.enable()

  _disableAddStickerButton: ->
    if @enabled
      @toggleStickers()
    @canDisplay = false
    @$el.find('.svg-icon-container').addClass('grayed')

  _enableAddStickerButton: ->
    @canDisplay = true
    @enabled = false
    @$el.find('.svg-icon-container').removeClass('grayed')

  _stickerIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/sticker-icon.svg'
      svgId: 'sticker-icon'
      iconClass: 'instagram-sticker-icon'
    )
